<template>
    <div>
        <el-row>
            <el-col :span="2"><span class="cascade-title">系列</span></el-col>
            <el-col :span="4">
                <el-select v-model="query.selectSeries" placeholder="请选择" @change="seriesChange($event)" :size="size">
                    <el-option v-for="item in series" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="2"><span class="cascade-title">级别</span></el-col>
            <el-col :span="4">
                <el-select v-model="query.selectLevels" placeholder="请选择" @change="levelsChange($event)" :size="size">
                    <el-option v-for="item in levels" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="2"><span class="cascade-title">单元</span></el-col>
            <el-col :span="4">
                <el-select v-model="query.selectUnits" placeholder="请选择" @change="unitsChange($event)" :size="size">
                    <el-option v-for="item in units" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6">
                <slot name="cascadeRightSpan">
                </slot>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import api from '@/utils/api'
export default {
    props: {
        size: {
            type: String,
            default: () => ('medium')
        },
        series: {
            type: Array,
            default: () => ([{ label: '168系列', value: 1 }, { label: '128系列', value: 2 }, { label: '一对一系列', value: 0 }])
        }
    },
    data () {
        return {
            levels: [],
            units: [],
            query: {
                selectSeries: '',
                selectLevels: '',
                selectUnits: ''
            }
        }
    },
    created () {

    },
    methods: {
        seriesChange (obj) {
            var _this = this
            _this.query.selectSeries = obj
            _this.$axios.get(api.getProductLevels)
                .then(res => {
                    _this.levels = [{ label: '请选择', value: '' }]
                    res.data.result.forEach((item, index) => {
                        _this.levels.push({ label: item.levelName, value: item.level })
                    })
                    this.$emit('change', this.query)
                })
        },
        levelsChange (obj) {
            var _this = this
            _this.query.selectLevels = obj
            _this.$axios.get(api.getProductUnitsForManage(_this.query.selectSeries, _this.query.selectLevels))
                .then(res => {
                    _this.units = [{ label: '请选择', value: '' }]
                    res.data.result.forEach((item, index) => {
                        _this.units.push({ label: item.unitName, value: item.unitNo })
                    })
                    this.$emit('change', this.query)
                })
        },
        unitsChange (obj) {
            this.query.selectUnits = obj
            this.$emit('change', this.query)
        }
    }
}
</script>
<style scoped lang="less">
.cascade-title {
    font-weight: 700;
    line-height: 40px;
    font-weight: 500;
    padding-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/cascadeQeury.vue